import { render } from "./CustomerServicePagination.vue?vue&type=template&id=a16a1370"
import script from "./CustomerServicePagination.vue?vue&type=script&lang=js"
export * from "./CustomerServicePagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__